module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar",
    on: {
      "click": function($event) {
        _vm.panelDown($event)
      }
    }
  }, [_c('ul', {
    staticClass: "controls"
  }, [_c('li', [_c('a', {
    class: {
      active: (_vm.zoomed), disabled: (_vm.surging)
    },
    attrs: {
      "title": "Zoom In"
    },
    on: {
      "click": _vm.zoomIn
    }
  }, [_vm._m(0)])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      active: (!_vm.zoomed), disabled: (_vm.surging)
    },
    attrs: {
      "title": "Zoom Out"
    },
    on: {
      "click": _vm.zoomOut
    }
  }, [_vm._m(1)])]), _vm._v(" "), _c('li', {
    staticClass: "divider"
  }), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "title": "Share"
    },
    on: {
      "click": _vm.shareApp
    }
  }, [_vm._m(2)]), _vm._v(" "), _c('share-controls')], 1), _vm._v(" "), (_vm.pdfDownload) ? _c('li', {
    staticClass: "divider"
  }) : _vm._e(), _vm._v(" "), (_vm.pdfDownload) ? _c('li', [_c('a', {
    attrs: {
      "href": _vm.pdfDownload,
      "title": "Download PDF",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        _vm.trackEvent('PDF Download', _vm.pdfDownload)
      }
    }
  }, [_vm._m(3)])]) : _vm._e(), _vm._v(" "), ((_vm.aboutPosition === 'sidebar')) ? _c('li', {
    staticClass: "divider"
  }) : _vm._e(), _vm._v(" "), _c('li', [((_vm.aboutPosition === 'sidebar')) ? _c('a', {
    attrs: {
      "title": "About"
    },
    on: {
      "click": function($event) {
        _vm.togglePanel('panel-content-about', 'about-us', $event)
      }
    }
  }, [_vm._m(4)]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "icon-MBR_zoom-in",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "icon-MBR_zoom-out",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "icon-MBR_share",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "icon-MBR_download",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "icon-MBR_information",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-edea1454","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SidebarControls.vue
// module id = 471
// module chunks = 1